import React, {memo} from 'react';
import s from './MyBtn.module.css'
import classNames from "classnames";
import {useAppSelector} from "../../../hooks/redux";

type PropsType = {
  fs?: string,
  width?: string,
  height?: string,
  padding?: string,
  title: string,
  onClick?: (e?: React.MouseEvent<HTMLButtonElement>) => void;
  type?: string;
  style?: React.CSSProperties;
  icon?: string;
  large?: boolean;
  medium?: boolean;
  small?: boolean;
  buttonType?: 'confirm' | 'error' | 'info';
  localDisable?: boolean;
  isPersonalAccountBtn?: boolean
}

const MyBtn: React.FC<PropsType> = memo(({
                                        type,
                                        title,
                                        icon,
                                        large,
                                        medium,
                                        small,
                                        buttonType,
                                        localDisable,
                                        isPersonalAccountBtn,
                                        onClick,
                                        ...props}) => {

    const {disabled} = useAppSelector(store => store.userReducer)



  return (
    <button onClick={onClick}
      style={{width: props.width, height: props.height, padding: props.padding, fontSize: props.fs}}
      className={classNames(isPersonalAccountBtn ? s.personal_btn : s.my_btn, {
      [s.large]: large,
      [s.medium]: medium,
      [s.small]: small,
      [s.disabled]: (disabled ? disabled : localDisable),
      [s.confirm]: buttonType === 'confirm',
      [s.error]: buttonType === 'error',
      [s.info]: buttonType === 'info',
    })}
            disabled={disabled ? disabled : localDisable}
            {...props}>
      {
        icon && <img className={s.img} src={icon} alt=""/>
      }
      {title}
    </button>
  );
});

export default MyBtn;
